import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import vipIcon from "@zhoujianhui/vip-icon"
import App from "./App"
import mockConfig from "../mock"
import "@fortawesome/fontawesome-free/css/all.css"
import createVipApp from "@zhoujianhui/vip-core"
import noticeManager from "@zhoujianhui/vip-notice-element"
import preventDoubleClick from "./common/pervent-double-click"
import btnResourceManager from './common/permission/btn-resource-manager'
//防止双击
Vue.use(preventDoubleClick)
Vue.prototype.checkPermission = function (value) {
    return btnResourceManager.checkPermission(value)
}
ElementUI.Dialog.props.lockScroll.default = false

// 引入ElementUI
Vue.use(ElementUI, {
    size: "small",
});

// 引入VIP图标组件
Vue.use(vipIcon)

Vue.config.productionTip = false;

(async () => {
    const app = await createVipApp(App, [
            noticeManager, // 通知管理器插件
        ], {
            mockConfig: mockConfig // mock配置
        }
    )

    // 初始化按钮权限
    await btnResourceManager.initPermission()

    if (app) {
        app.$mount("#app")
    }
})()
